import { mergeStyleSets } from "@fluentui/react";

export const footerStyle = mergeStyleSets({
  footer: {
    // backgroundColor: "#000000",
    // color: "#ffffff",
    backgroundColor: "var(--footer-background, #000000)",
    color: "var(--text-color, #ffffff)",
    padding: "10px 0",
    textAlign: "center",
    marginTop: "auto",
    position: "fixed",
    bottom: 0,
    width: "100%",
    zIndex: 1000,
    // ".theme-dark &": { // Only apply in dark mode
    //   backgroundColor: "var(--footer-background)",
    //   color: "var(--text-color)",
    // }
  },
  link: {
    // color: "#0078d4",
    color: "var(--link-color, #0078d4)",
    margin: "0 5px",
    textDecoration: "none",
    selectors: {
      ":hover": {
        color: "#0078d4",
        textDecoration: "underline",
      },
    },
    // ".theme-dark &": {
    //   color: "var(--link-color)",
    //   selectors: {
    //     ":hover": {
    //       color: "var(--link-color)",
    //     }
    //   }
    // },
  },
  linkContainer: {
    marginBottom: 10,
    padding: "0 10px",
  },
});
